import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

export default function ClaimJobEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IEmailTemplate_SenderEmail}}', title: lang.senderEmail },
            { id: '{{ClaimJob_StatusCode}}', title: lang.claimJobStatus },
            { id: '{{ClaimJob_AuthorizationNumber}}', title: lang.claimJobAuthorizationNumber },
            { id: '{{ClaimJobDetail_Comments}}', title: lang.claimJobNotes },
            { id: '{{ClaimJobDetail_Details}}', title: `${lang.claimJob} ${lang.details}` },
            { id: '{{ClaimJobDetail_Number}}', title: `${lang.claimJob} ${lang.number}` },
            { id: '{{ClaimJobDetail_TotalAmount}}', title: lang.totalAmount },
            { id: '{{ClaimJobDetail_TotalTaxAmount}}', title: lang.totalTax },
            { id: '{{ClaimJobDetail_TotalAmountWithTax}}', title: lang.totalAmountWithTaxes },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
